import { Navigate, useLocation } from "react-router-dom";
import { useStoreWrapper } from "../../store/store";
import { MUST_CHANGE_PASSWORD_KEY } from "../../api/authApi";

/**
 * Reads the .NET mustChangePassword flag, not user.firstTimeLoggedIn, which is never
 * cleared any more and would bounce valid sessions back to sign-in.
 */
const owesPasswordChange = () =>
  localStorage.getItem(MUST_CHANGE_PASSWORD_KEY) === "true";

export function PrivateRoute({ children }: { children: any }) {
  const user = useStoreWrapper((state) => state.user);
  const auth = localStorage.getItem("accessToken");
  const isAuthenticated = auth && user !== null && !owesPasswordChange();
  if (!isAuthenticated) {
    const lastPath = window.location.pathname;
    if (lastPath) window.location.replace(`/?lastPath=${lastPath}`);
  }
  return isAuthenticated ? children : <Navigate to={"/"} />;
}

export function AuthRoute({ children }: { children: any }) {
  const user = useStoreWrapper((state) => state.user);
  const auth = localStorage.getItem("accessToken");
  const isAuthenticated = auth && user !== null && !owesPasswordChange();
  return isAuthenticated ? <Navigate to="/" /> : children;
}

export function PublicRoute({ children }: { children: any }) {
  const user = useStoreWrapper((state) => state.user);
  const auth = localStorage.getItem("accessToken");
  const isAuthenticated = auth && user !== null && !owesPasswordChange();
  const location = useLocation();
  const lastPath = location.search
    ? new URLSearchParams(location.search).get("lastPath")
    : "";

  return isAuthenticated ? (
    <Navigate to={lastPath || "/user/dashboard"} />
  ) : (
    children
  );
}
